import React from 'react'
import { Modal, Spinner } from 'react-bootstrap'
import Button from 'react-bootstrap/Button'
import useTheme from '../hooks/useTheme'

interface Props {
	optionString: string
	onClose: () => void
	isLoading: boolean
	handleSubmit: () => void
}

const DeleteOptionModal: React.FC<Props> = ({
	optionString,
	onClose,
	isLoading,
	handleSubmit,
}) => {
	const theme = useTheme()
	return (
		<Modal
			style={{ '--bs-modal-color': 'var(--bs-body-color)' } as any}
			data-bs-theme={theme}
			show={!!optionString}
			onHide={onClose}
		>
			<div>
				<Modal.Header closeButton>
					<Modal.Title>Видалення категорії</Modal.Title>
				</Modal.Header>

				<Modal.Body>
					<p>
						Ви впевненні що хочете видалити категорію <br /> {optionString}?
					</p>
				</Modal.Body>

				<Modal.Footer>
					<Button onClick={onClose} variant="secondary">
						Закрити
					</Button>
					<Button onClick={handleSubmit} disabled={isLoading} variant="primary">
						Підтвердити
						{isLoading && (
							<Spinner className="ms-1" animation="border" size="sm" />
						)}
					</Button>
				</Modal.Footer>
			</div>
		</Modal>
	)
}

export default DeleteOptionModal
